// Reveal on scroll — shared across all pages
(() => {
  const els = document.querySelectorAll('[data-reveal]');
  requestAnimationFrame(() => {
    els.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-revealed');
    });
  });
  setTimeout(() => els.forEach((el) => el.classList.add('is-revealed')), 1500);
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });
  els.forEach((el) => io.observe(el));
})();
